import {makeReducer, match} from 'web-app/util/redux';
import {type ModalState, open, close} from 'web-app/react/modals-container/types';

import * as Actions from './actions';

/*
|----------------------------------------------------------------------------------------------------------------------
| Types
|----------------------------------------------------------------------------------------------------------------------
*/
export type RegisterTemperatureModalState = ModalState<{
    childId: string;
}>;

/*
|----------------------------------------------------------------------------------------------------------------------
| Reducer
|----------------------------------------------------------------------------------------------------------------------
*/
export default makeReducer<RegisterTemperatureModalState>(
    [
        match(Actions.show, (_, {payload}) =>
            open({
                childId: payload.childId,
            }),
        ),
        match(Actions.hide, () => close()),
        match(Actions.registerTemperatureSuccess, () => close()),
    ],
    close(),
);
